import "./App.css";
import RowGroup from "./components/RowGroup";

function App() {
  return (
    <div className="App">
      <h2 id="header"> AUDIO LOOPER</h2>
      <RowGroup />
    </div>
  );
}

export default App;
